module.exports = __webpack_public_path__ + "static/media/AFA_logo.00ea4a14.png";